import { render, staticRenderFns } from "./indexV.vue?vue&type=template&id=f1547e4c&scoped=true"
import script from "./indexV.vue?vue&type=script&lang=js"
export * from "./indexV.vue?vue&type=script&lang=js"
import style0 from "./indexV.vue?vue&type=style&index=0&id=f1547e4c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1547e4c",
  null
  
)

export default component.exports